import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  bucket: string = 'https://s3.us-east-2.amazonaws.com/dolancy-app';
}
